import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { BaseFormComponent } from '@core/components/base-form.component';
import { MarcatoreCorpoAbilitatoDto } from '@core/http-gen/models';
import { MarcatoreService } from '@core/http-gen/services';
import { ToastService } from '@core/services/toast.service';
import { tipoMarcatoreList, statoMarcatoreList } from '@core/utils/marcatore.utils';
import { NgxAuthService } from 'ngx-auth-utils';

@Component({
    selector: 'app-new-marcatore',
    templateUrl: './new-marcatore.component.html',
    styleUrl: './new-marcatore.component.scss',
})
export class NewMarcatoreComponent extends BaseFormComponent implements OnInit {
    public formGroup: FormGroup;
    public corpiAbilitati: { value: number; label: string }[] = [];

    public tipoMarcatoreList = tipoMarcatoreList;
    public statoMarcatoreList = statoMarcatoreList;

    constructor(
        private formBuilder: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private route: Router,
        private marcatoreService: MarcatoreService,
        private toastService: ToastService,
        private authService: NgxAuthService,
    ) {
        super();

        this.formGroup = this.formBuilder.group({
            nome: [null, [Validators.required, Validators.minLength(3)]],
            corpoId: [null, [Validators.required]],
            tipoMarcatore: [null, [Validators.required, Validators.pattern(/^\d+$/)]],
            descrizione: [null, Validators.minLength(3)],
            ultimoControllo: [null],
            statoMarcatore: [null],
            posizione: this.formBuilder.group({
                x: [null, [Validators.required]],
                y: [null, [Validators.required]],
            }),
        });

        this.formGroup.get('statoMarcatore')?.disable();
    }

    ngOnInit(): void {
        this.loadCoordinatesFromRoute();
        this.setCorpiAbilitati();
    }

    /** Carica le coordinate dall'url, se disponibili altrimenti non fa nulla */
    private loadCoordinatesFromRoute(): void {
        const x = parseFloat(this.activatedRoute.snapshot.queryParams['lon']);
        const y = parseFloat(this.activatedRoute.snapshot.queryParams['lat']);

        if (isNaN(x) || isNaN(y)) {
            console.error('Coordinate non valide:', x, y);
            return;
        }

        this.formGroup.get('posizione.x')?.setValue(parseFloat(x.toFixed(6)));
        this.formGroup.get('posizione.y')?.setValue(parseFloat(y.toFixed(6)));
    }

    private redirectToMap(): void {
        const mapZoom = this.activatedRoute.snapshot.queryParams['zoom'] || null;
        const mapCenterLon = this.activatedRoute.snapshot.queryParams['centerLon'] || null;
        const mapCenterLat = this.activatedRoute.snapshot.queryParams['centerLat'] || null;

        this.route.navigate(['/mappa'], {
            queryParams: {
                zoom: mapZoom,
                centerLon: mapCenterLon,
                centerLat: mapCenterLat,
            },
        });
    }

    public generateNewName(): void {
        const tipoMarcatore = this.formGroup.get('tipoMarcatore')?.value;
        const tipoMarcatoreLabel = this.tipoMarcatoreList.find((item) => item.value === tipoMarcatore)?.label;

        if (tipoMarcatore) {
            this.formGroup.get('nome')?.setValue(tipoMarcatoreLabel);
        } else {
            console.error('tipo marcatore non disponibile per generare il nome');
        }
    }

    public onSubmit(): void {
        if (this.formGroup.invalid) {
            this.formGroup.markAllAsTouched();
            console.error('Form non valido:', this.formGroup.hasError);
            return;
        }

        this.marcatoreService.apiMarcatoreMarcatoreInsertPost({ body: this.formGroup.value }).subscribe(() => {
            this.toastService.success('Marcatore creato con successo');
            this.redirectToMap();
        });
    }

    private setCorpiAbilitati(): void {
        this.marcatoreService.apiMarcatoreMarcatoreCorpiAbilitatiGet({}).subscribe((corpiAbilitati) => {
            if (!corpiAbilitati) {
                this.toastService.error('Non puoi modificare il marcatore');
                this.route.navigate(['/mappa']);
                return;
            }

            this.corpiAbilitati = corpiAbilitati.map((corpo) => ({
                value: corpo.id,
                label: corpo.name,
            }));

            if (this.corpiAbilitati.length === 1) {
                this.formGroup.get('corpoId')?.setValue(this.corpiAbilitati[0].value);
            }
        });
    }

    public onCancel(): void {
        this.redirectToMap();
    }
}
